// extracted by mini-css-extract-plugin
export default {"link":"style_link__1tuso","centerGrid":"style_centerGrid__kscIu","img":"style_img__aVD5P","namegame":"style_namegame__MfXqJ","center":"style_center__PAkhK"};